<template>
  <div class="wrapper primary">{{ title }}</div>
</template>

<script>
export default {
  name: 'SimulationContentDeliverySidebarHeader',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 10px 0;
  border-top: 1px solid #d5d5d5;
  border-bottom: 1px solid #d5d5d5;
  color: white;
}
</style>
